import { render, staticRenderFns } from "./BadgeCod.vue?vue&type=template&id=2fcf3554&scoped=true&"
import script from "./BadgeCod.vue?vue&type=script&lang=js&"
export * from "./BadgeCod.vue?vue&type=script&lang=js&"
import style0 from "./BadgeCod.vue?vue&type=style&index=0&id=2fcf3554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcf3554",
  null
  
)

export default component.exports